import * as React from 'react'
import * as styles from './styles'

type Props = {
    title: string
    thumbnail: string
    publishedAt: string
    category: string
};

export const SmallArticleCard = ({ title, thumbnail, publishedAt, category }: Props) => {
    return (
        <article css={styles.card}>
            <figure>
                <div
                    css={[{
                        backgroundImage: `url(${thumbnail})`,
                        backgroundSize: `cover`,
                        backgroundPosition: `center`,
                    }, styles.thumbnail]}
                />
            </figure>
            <figcaption>
                <p css={styles.title}>{title}</p>
                <time css={styles.time}>{publishedAt}</time>
                <span css={styles.category}>{category}</span>
            </figcaption>
        </article>
    )
}